/**
 * Enhanced AnalyticsPage using the new component system
 * Demonstrates tabbed analytics dashboard with multiple data views
 */

import React, { useEffect, useState } from 'react';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  VStack,
  Text,
} from '@chakra-ui/react';
import { FiTrendingUp } from 'react-icons/fi';

// New component system imports
import { AdminLayout, Card } from '@grcs/components';

import { StudentAdvancedAnalytics } from './StudentAdvancedAnalytics';

export const AnalyticsPageEnhanced: React.FC = () => {
  const [activeTab, setActiveTab] = useState(() => {
    const savedIndex = localStorage.getItem('analyticsActiveTabIndex');
    return savedIndex !== null ? parseInt(savedIndex, 10) : 0;
  });

  useEffect(() => {
    localStorage.setItem('analyticsActiveTabIndex', activeTab.toString());
  }, [activeTab]);

  const handleTabChange = (index: number) => {
    console.log('Tab changed to:', index, 'Student Advanced');
    setActiveTab(index);
  };

  // Debug active tab state
  console.log('Analytics Page - Current active tab:', activeTab);

  return (
    <AdminLayout>
      <VStack spacing={8} align="stretch">
        {/* Header Section */}
        <div>
          <Text fontSize="2xl" fontWeight="bold" mb={2}>
            Analytics Dashboard
          </Text>
          <Text fontSize="lg" color="gray.600">
            Comprehensive performance metrics and insights
          </Text>
        </div>

        {/* Analytics Tabs */}
        <Card padding={0} overflow="hidden">
          <Tabs
            index={activeTab}
            onChange={handleTabChange}
            colorScheme="blue"
            variant="enclosed-colored"
          >
            <TabList borderBottom="1px solid" borderColor="gray.200">
              <Tab gap={2} py={4}>
                <FiTrendingUp />
                <span>Student Advanced</span>
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel p={6}>
                <StudentAdvancedAnalytics active={activeTab === 0} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Card>

        {/* Analytics Summary */}
        <Card padding={6} variant="outline">
          <VStack spacing={4} align="stretch">
            <Text fontSize="lg" fontWeight="600">
              Analytics Overview
            </Text>
            <div>
              <Text fontSize="sm" color="gray.600">
                Use the tabs above to explore different analytics views:
              </Text>
              <ul
                style={{
                  marginTop: '0.5rem',
                  paddingLeft: '1.5rem',
                  fontSize: '0.875rem',
                }}
              >
                <li>
                  <strong>Student Advanced:</strong> Reading speed by semester
                  with homework detail on hover
                </li>
              </ul>
            </div>
          </VStack>
        </Card>
      </VStack>
    </AdminLayout>
  );
};
